import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@justgiving/react-tracking';
import { useModalToggle } from '../../hooks';
import { ShareModal } from '../ShareModal/ShareModal';
import { MarkSuccessOnClick } from '../MarkSuccessOnClick/MarkSuccessOnClick';

export const Share: FunctionComponent = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { isOpen, setOpen } = useModalToggle();

  return (
    <>
      <MarkSuccessOnClick
        testSlug="b2c_social_share_button"
        successType="generic-share"
      >
        <Button
          className="jg-btn jg-btn--ghost"
          onClick={() => setOpen(true)}
          type="button"
          trackingData={{
            action_name: 'click',
            subtype: 'share',
            event: 'click',
            event_value: 'share',
          }}
        >
          {t('common.share')}
        </Button>
      </MarkSuccessOnClick>
      {isOpen ? <ShareModal onClose={() => setOpen(false)} /> : null}
    </>
  );
};
